import React, {useEffect, useRef, useState} from 'react'
import axios from 'axios'

import {EditorState, convertToRaw, ContentState} from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import {stateFromHTML} from 'draft-js-import-html'
import {Editor} from 'react-draft-wysiwyg'
import {convertToHTML, convertFromHTML} from 'draft-convert'
import htmlToDraft from 'html-to-draftjs'

import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

function General() {
  const url = 'https://puntosurgdl.com/backend/'

  const [youtube, setYoutube] = useState('')
  const [showAlertSuccess, setShowAlertSuccess] = useState(false)

  const [textSection, setTextSection] = useState('')
  const [editorRawHtml, setEditorRawHtml] = useState('')
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(editorRawHtml))
  )
  const [convertedContent, setConvertedContent] = useState(null)

  const clearTimerRef = useRef()

  const htmlToDraftBlocks = (html) => {
    const blocksFromHtml = htmlToDraft(html)
    const {contentBlocks, entityMap} = blocksFromHtml
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
    const editorState = EditorState.createWithContent(contentState)
    return editorState
  }

  useEffect(() => {
    let html = convertToHTML(editorState.getCurrentContent())
    setConvertedContent(html)
  }, [editorState])

  useEffect(() => {
    getGeneralElements()
    setEditorRawHtml()
  }, [editorRawHtml])

  const getGeneralElements = () => {
    axios
      .get(url + 'getGeneralElements.php')
      .then((response) => {
        let elements = response.data.data
        for (let key in elements) {
          switch (elements[key].idElement) {
            case 'link-youtube':
              console.log(elements[key])
              document.getElementById('link-youtube').value = elements[key].content
              break

            case 'link-twitter':
              console.log(elements[key])
              document.getElementById('link-twitter').value = elements[key].content
              break

            case 'link-instagram':
              console.log(elements[key])
              document.getElementById('link-instagram').value = elements[key].content
              break

            case 'link-facebook':
              console.log(elements[key])
              document.getElementById('link-facebook').value = elements[key].content
              break

            case 'contacto-telefono':
              console.log(elements[key])
              document.getElementById('contacto-telefono').value = elements[key].content
              break

            case 'contacto-correo':
              console.log(elements[key])
              document.getElementById('contacto-correo').value = elements[key].content
              break

            case 'contacto-dias':
              console.log(elements[key])
              document.getElementById('contacto-dias').value = elements[key].content
              break

            case 'contacto-horario':
              console.log(elements[key])
              document.getElementById('contacto-horario').value = elements[key].content
              break

            // case 'formulario-balcony':
            //   console.log(elements[key])
            //   document.getElementById('formulario-balcony').value = elements[key].content
            //   break

            case 'formulario-servicio':
              console.log(elements[key])
              document.getElementById('formulario-servicio').value = elements[key].content
              break

            case 'formulario-prospectos':
              console.log(elements[key])
              document.getElementById('formulario-prospectos').value = elements[key].content
              break

            case 'formulario-inscripcion':
              console.log(elements[key])
              document.getElementById('formulario-inscripcion').value = elements[key].content
              break

            case 'aviso-privacidad':
              console.log(elements[key])
              // setEditorRawHtml(elements[key].content)
              // setEditorState(() => EditorState.createWithContent(convertFromHTML(editorRawHtml)))
              // setTextSection(elements[key].content)
              setEditorState(htmlToDraftBlocks(elements[key].content))
              break

            default:
              break
          }
        }
        console.log(elements)

        //console.log(promos)
        // setPromos(promos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const updateGeneralElement = (elementName) => {
    setShowAlertSuccess(false)
    clearTimeout(clearTimerRef.current)
    let data = []
    if (elementName === 'aviso-privacidad') {
      const elementNameText = elementName

      // console.log(convertToHTML(editorState.getCurrentContent()))

      const rawContentState = convertToRaw(editorState.getCurrentContent())
      const markup = draftToHtml(rawContentState)
      console.log(markup)

      data = {
        name: elementNameText,
        content: markup,
      }
    } else {
      console.log(document.getElementById(elementName).value)

      const elementNameText = elementName
      const contentText = document.getElementById(elementName).value

      data = {
        name: elementNameText,
        content: contentText,
      }
    }

    axios
      .post(url + 'updateColumnIsActive.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          setShowAlertSuccess(true)

          clearTimerRef.current = setTimeout(function () {
            setShowAlertSuccess(false)
          }, 3000)
          // setCheckColumnPromo(columnIsActive)
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='row g-5'>
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Elementos generales</h3>
            {/* <div className='mt-10 mb-10 float-end'>
              <button type='button' className='btn btn-primary'>
                Agregar
              </button>
            </div> */}
          </div>
          <div className='card-body'>
            <h2>Enlaces redes sociales</h2>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Youtube:</label>
                <input type='text' className='form-control' id='link-youtube' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`link-youtube`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Twitter:</label>
                <input type='text' className='form-control' id='link-twitter' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`link-twitter`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Instagram:</label>
                <input type='text' className='form-control' id='link-instagram' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`link-instagram`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Facebook:</label>
                <input type='text' className='form-control' id='link-facebook' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`link-facebook`)}
                >
                  Guardar
                </button>
              </div>
            </div>

            <h2 className='mt-10'>Información de contacto</h2>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Teléfono:</label>
                <input type='text' className='form-control' id='contacto-telefono' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`contacto-telefono`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Correo:</label>
                <input type='text' className='form-control' id='contacto-correo' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`contacto-correo`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Dias:</label>
                <input type='text' className='form-control' id='contacto-dias' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`contacto-dias`)}
                >
                  Guardar
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-10'>
                <label>Horario:</label>
                <input type='text' className='form-control' id='contacto-horario' />
              </div>
              <div className='col-md-2 mt-6 float-end'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement(`contacto-horario`)}
                >
                  Guardar
                </button>
              </div>
            </div>

            <div className='row mt-20'>
              <h2>Aviso de privacidad</h2>
              <div className='form-group col-md-12'>
                <label>Contenido:</label>
                <Editor
                  editorState={editorState}
                  toolbarClassName='toolbarClassName'
                  wrapperClassName='wrapperClassName'
                  onEditorStateChange={setEditorState}
                />
              </div>
              <div className='col-md-2 mt-6 ms-auto'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => updateGeneralElement('aviso-privacidad')}
                >
                  Guardar
                </button>
              </div>
            </div>

            <div className='mt-20'>
              <h2>Formularios de página Contacto | Correos destinatarios</h2>
              {/* <div className='row'>
                <div className='form-group col-md-10'>
                  <label>Formulario Balcony:</label>
                  <input type='text' className='form-control' id='formulario-balcony' />
                </div>
                <div className='col-md-2 mt-6 float-end'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => updateGeneralElement(`formulario-balcony`)}
                  >
                    Guardar
                  </button>
                </div>
              </div> */}
              <div className='row'>
                <div className='form-group col-md-10'>
                  <label>Formulario Servicio al cliente:</label>
                  <input type='text' className='form-control' id='formulario-servicio' />
                </div>
                <div className='col-md-2 mt-6 float-end'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => updateGeneralElement(`formulario-servicio`)}
                  >
                    Guardar
                  </button>
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-md-10'>
                  <label>Formulario Prospectos Locatarios:</label>
                  <input type='text' className='form-control' id='formulario-prospectos' />
                </div>
                <div className='col-md-2 mt-6 float-end'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => updateGeneralElement(`formulario-prospectos`)}
                  >
                    Guardar
                  </button>
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-md-10'>
                  <label>Formulario Inscripción de Talento:</label>
                  <input type='text' className='form-control' id='formulario-inscripcion' />
                </div>
                <div className='col-md-2 mt-6 float-end'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => updateGeneralElement(`formulario-inscripcion`)}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input className='form-check-input' type='checkbox' value='' id='column-active' />
              <label className='form-check-label' for='column-active'>
                Habilitar columna única
              </label>
            </div>
          </div> */}
        </div>
      </div>
      <div className='row alert-container'>
        {showAlertSuccess ? (
          <div className='alert alert-success alert-dismissible bg-success d-flex flex-column flex-sm-row p-5 mb-10 col-md-6'>
            <span className='svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                class='mh-50px'
              >
                <path
                  opacity='0.3'
                  d='M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z'
                  fill='black'
                ></path>
                <path
                  d='M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z'
                  fill='black'
                ></path>
              </svg>
            </span>
            <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
              <h3 className='mb-1'>Cambios guardados con éxito</h3>
            </div>
          </div>
        ) : (
          <div></div>
        )}{' '}
      </div>
    </div>
  )
}

export {General}
